import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class commentSwitcherComponent extends Component {
  get moreCommentsNumber() {
    return this.args.item.comments.length - 2;
  }
  get commentReadMore() {
    if (this.args.item.comments.length > 2) {
      return true;
    }
    return false;
  }

  @action
  isActive(comment) {
    if (this.args.activeComment) {
      return this.args.activeComment == comment;
    }
  }

  @action
  async openAndActivate(comment) {
    this.args.openList();
    this.activate(comment);
  }

  @action
  async activate(comment) {
    if (this.args.onActivate) {
      this.args.onActivate(comment);
    }
  }
}
